import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccessControlDirective} from './acess-control/access-control.directive';
import { ComplyRoundNumberDirective } from './round-number.directive';
import { FocusTrapDirective } from './focus-trap.directive';
import { EdlCommonDirectiveModule } from '@edl-development/edl-common';

@NgModule({
    imports: [
        CommonModule,
        EdlCommonDirectiveModule
    ],
    declarations: [
        AccessControlDirective,
        ComplyRoundNumberDirective,
        FocusTrapDirective
    ],
    exports: [
        AccessControlDirective,
        ComplyRoundNumberDirective,
        FocusTrapDirective,
        EdlCommonDirectiveModule
    ]
})
export class ComplyDirectivesModule { }